export default "__VITE_ASSET__662c737f__"